export default "__VITE_ASSET__JWCNSx$d__"